(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-pricing"] && !Shopify.designMode) return;
  try {
    
/* ---------- UK business-day delivery date ---------- */
(function () {
  var UK_HOLIDAYS = [
    '2025-01-01','2025-04-18','2025-04-21','2025-05-05','2025-05-26','2025-08-25','2025-12-25','2025-12-26',
    '2026-01-01','2026-04-03','2026-04-06','2026-05-04','2026-05-25','2026-08-31','2026-12-25','2026-12-28',
    '2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28',
    '2028-01-03','2028-04-14','2028-04-17','2028-05-01','2028-05-29','2028-08-28','2028-12-25','2028-12-26',
    '2029-01-01','2029-03-30','2029-04-02','2029-05-07','2029-05-28','2029-08-27','2029-12-25','2029-12-26',
    '2030-01-01','2030-04-19','2030-04-22','2030-05-06','2030-05-27','2030-08-26','2030-12-25','2030-12-26'
  ];
  function ymd(d){
    var fmt = new Intl.DateTimeFormat('en-CA', { timeZone:'Europe/London', year:'numeric', month:'2-digit', day:'2-digit' });
    var parts = fmt.formatToParts(d).reduce(function(a,p){a[p.type]=p.value;return a;},{});
    return parts.year + '-' + parts.month + '-' + parts.day;
  }
  function londonNow(){ return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' })); }
  function isWeekend(d){ var wd = d.getDay(); return wd === 0 || wd === 6; }
  function addBusinessDays(start, n, holidaySet){
    var d = new Date(start);
    while (n > 0){
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d) && !holidaySet[ymd(d)]) n--;
    }
    return d;
  }
  function formatDate(d){
    return new Intl.DateTimeFormat('en-GB', { timeZone:'Europe/London', weekday:'long', day:'numeric', month:'long' }).format(d);
  }
  function formatShort(d){
    return new Intl.DateTimeFormat('en-GB', { timeZone:'Europe/London', day:'numeric', month:'short' }).format(d);
  }
  function initDeliveryDate(){
    document.querySelectorAll('.bundles-section .hyp-del-date').forEach(function (host) {
      var el = host.querySelector('.hyp-delivery-date-out');
      if (!el) return;
      var cutoffH = parseInt(host.dataset.edCutoffHour, 10); if (isNaN(cutoffH)) cutoffH = 13;
      var cutoffM = parseInt(host.dataset.edCutoffMinute, 10); if (isNaN(cutoffM)) cutoffM = 30;
      var minDays = parseInt(host.dataset.edDeliveryDays, 10); if (isNaN(minDays)) minDays = 1;
      var gap = parseInt(host.dataset.edDeliveryGap, 10); if (isNaN(gap)) gap = 0;
      var useUK = host.dataset.edIncludeUkHolidays === 'true';
      var extra = (host.dataset.edExtraHolidays || '').split(/[\s,]+/).filter(Boolean);
      var holidaySet = {};
      if (useUK) UK_HOLIDAYS.forEach(function(d){ holidaySet[d] = true; });
      extra.forEach(function(d){ holidaySet[d] = true; });
      var now = londonNow();

      // ----- special window: Thu 15:30 -> Sun 12:00 (London) -----
      var specialMsg = host.dataset.edSpecialMsg || '';
      function inSpecialWindow(d){
        var day=d.getDay(), mins=d.getHours()*60+d.getMinutes();
        if(day===4) return mins>=(15*60+30);
        if(day===5||day===6) return true;
        if(day===0) return mins<(12*60);
        return false;
      }
      if(specialMsg && inSpecialWindow(now)){ el.textContent = specialMsg; return; }

      var afterCutoff = (now.getHours() > cutoffH) || (now.getHours() === cutoffH && now.getMinutes() >= cutoffM);
      var bump = afterCutoff ? 1 : 0;
      var earliest = addBusinessDays(now, minDays + bump, holidaySet);
      if (gap > 0){
        var latest = addBusinessDays(earliest, gap, holidaySet);
        el.textContent = formatShort(earliest) + ' \u2013 ' + formatShort(latest);
      } else {
        el.textContent = formatDate(earliest);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryDate);
  } else { initDeliveryDate(); }
})();

document.querySelectorAll('.bundles-section').forEach(function (section) {
  var cards = section.querySelectorAll('.bundle-card');
  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('.bundle-cta')) return;
      cards.forEach(function (c) { c.classList.remove('selected'); });
      card.classList.add('selected');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-card"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faqc-section').forEach(function (section) {
  var items = section.querySelectorAll('.faqc-item');
  // Ensure the first item starts open if it was marked to (robust against
  // any markup/state quirks in the theme editor)
  if (items.length && items[0].classList.contains('open')) {
    var firstBtn = items[0].querySelector('.faqc-q');
    if (firstBtn) firstBtn.setAttribute('aria-expanded', 'true');
  }
  items.forEach(function (item) {
    var btn = item.querySelector('.faqc-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var wasOpen = item.classList.contains('open');
      items.forEach(function (el) {
        el.classList.remove('open');
        var b = el.querySelector('.faqc-q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq-section').forEach(function (section) {
  var items = section.querySelectorAll('.faq-item');
  items.forEach(function (item) {
    var btn = item.querySelector('.faq-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var wasOpen = item.classList.contains('open');
      items.forEach(function (el) {
        el.classList.remove('open');
        var b = el.querySelector('.faq-q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var UK_HOLIDAYS = [
    '2025-01-01','2025-04-18','2025-04-21','2025-05-05','2025-05-26','2025-08-25','2025-12-25','2025-12-26',
    '2026-01-01','2026-04-03','2026-04-06','2026-05-04','2026-05-25','2026-08-31','2026-12-25','2026-12-28',
    '2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28',
    '2028-01-03','2028-04-14','2028-04-17','2028-05-01','2028-05-29','2028-08-28','2028-12-25','2028-12-26',
    '2029-01-01','2029-03-30','2029-04-02','2029-05-07','2029-05-28','2029-08-27','2029-12-25','2029-12-26',
    '2030-01-01','2030-04-19','2030-04-22','2030-05-06','2030-05-27','2030-08-26','2030-12-25','2030-12-26'
  ];

  function ymd(d){
    var fmt = new Intl.DateTimeFormat('en-CA', { timeZone:'Europe/London', year:'numeric', month:'2-digit', day:'2-digit' });
    var parts = fmt.formatToParts(d).reduce(function(a,p){a[p.type]=p.value;return a;},{});
    return parts.year + '-' + parts.month + '-' + parts.day;
  }
  function londonNow(){
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
  }
  function isWeekend(d){ var wd = d.getDay(); return wd === 0 || wd === 6; }
  function addBusinessDays(start, n, holidaySet){
    var d = new Date(start);
    while (n > 0){
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d) && !holidaySet[ymd(d)]) n--;
    }
    return d;
  }
  function formatDate(d){
    return new Intl.DateTimeFormat('en-GB', { timeZone:'Europe/London', weekday:'long', day:'numeric', month:'long' }).format(d);
  }
  function formatShort(d){
    return new Intl.DateTimeFormat('en-GB', { timeZone:'Europe/London', day:'numeric', month:'short' }).format(d);
  }
  function initDeliveryDate(){
    var host = document.querySelector('.hyp-del-date');
    var el = document.getElementById('hyp-delivery-date');
    if (!host || !el) return;

    var cutoffH = parseInt(host.dataset.edCutoffHour, 10); if (isNaN(cutoffH)) cutoffH = 13;
    var cutoffM = parseInt(host.dataset.edCutoffMinute, 10); if (isNaN(cutoffM)) cutoffM = 30;
    var minDays = parseInt(host.dataset.edDeliveryDays, 10); if (isNaN(minDays)) minDays = 1;
    var gap = parseInt(host.dataset.edDeliveryGap, 10); if (isNaN(gap)) gap = 0;
    var useUK = host.dataset.edIncludeUkHolidays === 'true';
    var extra = (host.dataset.edExtraHolidays || '').split(/[\s,]+/).filter(Boolean);

    var holidaySet = {};
    if (useUK) UK_HOLIDAYS.forEach(function(d){ holidaySet[d] = true; });
    extra.forEach(function(d){ holidaySet[d] = true; });

    var now = londonNow();

    // ----- special window: Thu 15:30 -> Sun 12:00 (London) -----
    var specialMsg = host.dataset.edSpecialMsg || '';
    function inSpecialWindow(d){
      var day=d.getDay(), mins=d.getHours()*60+d.getMinutes();
      if(day===4) return mins>=(15*60+30);
      if(day===5||day===6) return true;
      if(day===0) return mins<(12*60);
      return false;
    }
    if(specialMsg && inSpecialWindow(now)){ el.textContent = specialMsg; return; }

    var afterCutoff = (now.getHours() > cutoffH) || (now.getHours() === cutoffH && now.getMinutes() >= cutoffM);
    var bump = afterCutoff ? 1 : 0;

    var earliest = addBusinessDays(now, minDays + bump, holidaySet);
    if (gap > 0){
      var latest = addBusinessDays(earliest, gap, holidaySet);
      el.textContent = formatShort(earliest) + ' – ' + formatShort(latest);
    } else {
      el.textContent = formatDate(earliest);
    }
  }

  document.querySelectorAll('.product-hero').forEach(function (hero) {
    var form = hero.querySelector('.ph-form');
    var idField = form ? form.querySelector('input[name="id"]') : null;
    var qtyField = form ? form.querySelector('input[name="quantity"]') : null;
    var opts = hero.querySelectorAll('.ph-price-opt');

    function applyOption(opt) {
      var radio = opt.querySelector('.ph-variant-radio');
      if (!radio) return;
      opts.forEach(function (o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
      var vid = radio.getAttribute('data-variant-id');
      var qty = radio.getAttribute('data-quantity');
      if (idField && vid) idField.value = vid;
      if (qtyField && qty) qtyField.value = qty;
    }

    opts.forEach(function (opt) {
      var radio = opt.querySelector('.ph-variant-radio');
      if (!radio) return;
      radio.addEventListener('change', function () {
        if (radio.checked) applyOption(opt);
      });
      if (radio.checked) applyOption(opt);
    });

    var featured = hero.querySelector('.ph-bottle-img');
    hero.querySelectorAll('.ph-thumb-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (featured && btn.dataset.full) featured.src = btn.dataset.full;
        hero.querySelectorAll('.ph-thumb-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryDate);
  } else { initDeliveryDate(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policy-content"] && !Shopify.designMode) return;
  try {
    
(function () {
  function slugify(text, used) {
    var base = (text || 'section').toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 50) || 'section';
    var slug = base, i = 2;
    while (used[slug]) { slug = base + '-' + i; i++; }
    used[slug] = true;
    return slug;
  }

  document.querySelectorAll('[data-policy]').forEach(function (root) {
    var content = root.querySelector('[data-policy-content]');
    var tocAside = root.querySelector('[data-policy-toc]');
    var tocList = root.querySelector('[data-toc-list]');
    var grid = root.querySelector('.policy-grid');
    if (!content || !tocList) return;

    // Collect top-level headings from the page content (skip the help CTA)
    var headings = [].slice.call(content.querySelectorAll('h2'))
      .filter(function (h) { return !h.closest('.help-cta'); });

    if (headings.length < 2) {
      // Not enough sections to warrant a TOC — go full width
      if (grid) grid.classList.add('policy-grid--no-toc');
      return;
    }

    var used = {};
    var links = [];
    headings.forEach(function (h) {
      if (!h.id) h.id = slugify(h.textContent, used);
      else used[h.id] = true;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + h.id);
      });
      li.appendChild(a);
      tocList.appendChild(li);
      links.push({ a: a, h: h });
    });

    if (tocAside) tocAside.hidden = false;

    // Scroll-spy: highlight the active section
    function onScroll() {
      var pos = window.scrollY + 120;
      var current = links[0];
      links.forEach(function (item) {
        if (item.h.offsetTop <= pos) current = item;
      });
      links.forEach(function (item) {
        item.a.classList.toggle('is-active', item === current);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // If the page was opened with a hash, jump to it
    if (window.location.hash) {
      var target = content.querySelector(window.location.hash);
      if (target) setTimeout(function () {
        target.scrollIntoView({ block: 'start' });
      }, 80);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tabs-section').forEach(function (section) {
  var tabs = section.querySelectorAll('.tab');
  var panes = section.querySelectorAll('.tab-pane');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.dataset.tab;
      tabs.forEach(function (t) { t.classList.remove('active'); });
      panes.forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active');
      var pane = section.querySelector('#tab-' + target);
      if (pane) pane.classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-quiz]').forEach(function (card) {
  var questions = [];
  var benefitMap = {};
  var sid = card.getAttribute('data-section-id');
  var qNode = document.getElementById('QuizQuestions-' + sid) ||
              document.querySelector('[data-quiz-questions]');
  var bNode = document.getElementById('QuizBenefits-' + sid) ||
              document.querySelector('[data-quiz-benefits]');
  try {
    questions = JSON.parse(qNode.textContent);
    benefitMap = JSON.parse(bNode.textContent);
  } catch (e) {
    var fallbackEl = card.querySelector('[data-question-text]');
    if (fallbackEl) fallbackEl.textContent = 'This quiz needs at least one question. Add question blocks in the theme editor.';
    return;
  }
  if (!questions.length) {
    var emptyEl = card.querySelector('[data-question-text]');
    if (emptyEl) emptyEl.textContent = 'This quiz needs at least one question. Add question blocks in the theme editor.';
    return;
  }

  var elQuestion = card.querySelector('[data-question-text]');
  var elOptions = card.querySelector('[data-quiz-options]');
  var elFill = card.querySelector('[data-progress-fill]');
  var elCurrent = card.querySelector('[data-q-current]');
  var elTotal = card.querySelector('[data-q-total]');
  var elPct = card.querySelector('[data-progress-pct]');
  var elQuizQuestion = card.querySelector('[data-quiz-question]');
  var elProgressInfo = card.querySelector('.progress-info');
  var elResult = card.querySelector('[data-result-screen]');
  var elRejection = card.querySelector('[data-rejection-screen]');
  var elConsult = card.querySelector('[data-consult-doctor]');
  var elWhyList = card.querySelector('[data-why-list]');
  var elHeading = card.querySelector('[data-result-heading]');
  var elIntro = card.querySelector('[data-result-intro]');

  var currentQ = 0;
  var collectedTags = {};

  if (elTotal) elTotal.textContent = questions.length;

  function renderQuestion(idx) {
    var question = questions[idx];
    elQuestion.textContent = question.q;
    elOptions.innerHTML = '';
    question.options.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'quiz-option';
      btn.innerHTML = '<span class="dot"></span><span></span>';
      btn.querySelector('span:last-child').textContent = opt.text;
      btn.addEventListener('click', function () { selectOption(opt); });
      elOptions.appendChild(btn);
    });
    if (elCurrent) elCurrent.textContent = idx + 1;
    var pct = Math.round((idx / questions.length) * 100);
    if (elFill) elFill.style.width = pct + '%';
    if (elPct) elPct.textContent = pct + '%';
  }

  function selectOption(opt) {
    if (opt.tags.indexOf('underage') !== -1) { showRejection(); return; }
    opt.tags.forEach(function (t) { if (t) collectedTags[t] = true; });
    currentQ++;
    if (currentQ >= questions.length) { showResult(); }
    else { renderQuestion(currentQ); }
  }

  function showRejection() {
    elQuizQuestion.style.display = 'none';
    if (elProgressInfo) elProgressInfo.style.display = 'none';
    elRejection.classList.add('active');
    card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function showResult() {
    if (elFill) elFill.style.width = '100%';
    if (elPct) elPct.textContent = '100%';
    elQuizQuestion.style.display = 'none';
    if (elProgressInfo) elProgressInfo.style.display = 'none';
    elResult.classList.add('active');

    var tags = Object.keys(collectedTags);
    var tagsToShow = tags.slice();
    if (tagsToShow.length < 3) {
      ['fall_asleep', 'natural', 'morning_fog'].forEach(function (d) {
        if (tagsToShow.indexOf(d) === -1) tagsToShow.push(d);
      });
    }
    tagsToShow = tagsToShow.slice(0, 4);

    if (elWhyList) {
      elWhyList.innerHTML = '';
      tagsToShow.forEach(function (tag) {
        var benefit = benefitMap[tag];
        if (!benefit) return;
        var li = document.createElement('li');
        li.innerHTML = '<span><strong>' + benefit.title + '.</strong> ' + benefit.text + '</span>';
        elWhyList.appendChild(li);
      });
    }

    if (collectedTags['heavy_meds'] && elConsult) elConsult.style.display = 'flex';
    card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* Email form — submits to Shopify, creates a tagged customer.
     The base tag plus all collected quiz answer tags are written into
     the hidden contact[tags] field just before the form submits. */
  var emailForm = card.querySelector('[data-email-form]');
  var emailFormEl = emailForm ? emailForm.closest('form') : null;
  var quizTagsField = card.querySelector('[data-quiz-tags]');
  var quizNoteField = card.querySelector('[data-quiz-note]');
  var baseTag = quizTagsField ? quizTagsField.value : '';

  function buildTagString() {
    var tags = [];
    // baseTag = the per-quiz tag, e.g. "quiz-3am-wake" (set in the template)
    if (baseTag) tags.push(baseTag);
    // a generic marker so you can segment "anyone who did any quiz"
    tags.push('quiz-taken');
    // answer tags, namespaced under the quiz tag so they never collide
    // between quizzes: e.g. "quiz-3am-wake-cortisol"
    var prefix = baseTag ? baseTag + '-' : 'quiz-';
    Object.keys(collectedTags).forEach(function (t) {
      if (!t) return;
      tags.push(prefix + t);   // quiz-specific answer tag (for segmentation)
      tags.push('quiz-' + t);  // generic answer tag (cross-quiz themes)
    });
    return tags.join(', ');
  }

  if (emailFormEl) {
    emailFormEl.addEventListener('submit', function () {
      // inject the quiz tags + a readable note right before the POST
      if (quizTagsField) quizTagsField.value = buildTagString();
      if (quizNoteField) {
        var quizName = baseTag || 'quiz';
        quizNoteField.value = '[' + quizName + '] answers: ' +
          (Object.keys(collectedTags).join(', ') || 'none');
      }
      // let the native submit proceed
    });
  }

  // If Shopify reloaded the page after a successful post, show success
  if (card.querySelector('[data-form-posted]')) {
    if (elResult) elResult.classList.add('active');
    if (elQuizQuestion) elQuizQuestion.style.display = 'none';
    if (elProgressInfo) elProgressInfo.style.display = 'none';
    if (emailForm) emailForm.style.display = 'none';
    var successEl = card.querySelector('[data-email-success]');
    if (successEl) successEl.classList.add('show');
  }
  // Show any Shopify form error
  var formErr = card.querySelector('[data-form-error]');
  if (formErr) {
    var errBox = card.querySelector('[data-email-error]');
    if (errBox) {
      errBox.textContent = formErr.textContent;
      errBox.hidden = false;
    }
    if (elResult) elResult.classList.add('active');
    if (elQuizQuestion) elQuizQuestion.style.display = 'none';
    if (elProgressInfo) elProgressInfo.style.display = 'none';
  }

  /* Restart */
  card.querySelectorAll('[data-restart]').forEach(function (link) {
    link.addEventListener('click', function () {
      currentQ = 0;
      collectedTags = {};
      elQuizQuestion.style.display = 'block';
      if (elProgressInfo) elProgressInfo.style.display = 'flex';
      elResult.classList.remove('active');
      elRejection.classList.remove('active');
      if (elConsult) elConsult.style.display = 'none';
      if (emailForm) emailForm.style.display = 'flex';
      var success = card.querySelector('[data-email-success]');
      if (success) success.classList.remove('show');
      var input = card.querySelector('[data-email-input]');
      if (input) input.value = '';
      renderQuestion(0);
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  renderQuestion(0);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sceptic-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function buildFileVideo(src){
    var v = document.createElement('video');
    v.className = 'sceptic-embed';
    v.src = src;
    v.controls = true;
    v.playsInline = true;
    v.setAttribute('playsinline','');
    v.preload = 'auto';
    return v;
  }

  function playInline(card){
    var box = card.querySelector('.sceptic-video');
    if (!box || box.classList.contains('is-playing')) return;
    var type = card.getAttribute('data-video-type');
    var id = card.getAttribute('data-video-id');
    if (!type) return;

    var node;
    if (type === 'youtube') {
      node = document.createElement('iframe');
      node.className = 'sceptic-embed';
      node.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
      node.allow = 'autoplay; encrypted-media; picture-in-picture';
      node.setAttribute('allowfullscreen','');
    } else if (type === 'vimeo') {
      node = document.createElement('iframe');
      node.className = 'sceptic-embed';
      node.src = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
      node.allow = 'autoplay; fullscreen; picture-in-picture';
      node.setAttribute('allowfullscreen','');
    } else { // direct / Shopify Files .mp4
      node = card._preloadedVideo || buildFileVideo(id);
      node.autoplay = true;
      box.classList.add('is-loading');
      var clearSpin = function(){ box.classList.remove('is-loading'); };
      if (node.readyState >= 3) { clearSpin(); }
      else {
        node.addEventListener('canplay', clearSpin, { once: true });
        node.addEventListener('playing', clearSpin, { once: true });
        node.addEventListener('error', clearSpin, { once: true });
      }
    }
    var btn = box.querySelector('.sceptic-play');
    if (btn) btn.remove();
    box.classList.add('is-playing');
    if (node.parentNode !== box) box.appendChild(node);
    if (node.play) { try { node.play(); } catch(e){} }
  }

  function init(){
    document.querySelectorAll('.sceptic-card.has-video').forEach(function (card) {
      var box = card.querySelector('.sceptic-video');
      if (!box) return;
      var type = card.getAttribute('data-video-type');
      var id = card.getAttribute('data-video-id');
      if (type === 'file' && id) {
        var preload = function(){
          if (card._preloadedVideo) return;
          var v = buildFileVideo(id);
          card._preloadedVideo = v;
          v.load();
        };
        box.addEventListener('mouseenter', preload, { once: true });
        box.addEventListener('touchstart', preload, { once: true, passive: true });
      }
      box.addEventListener('click', function(){ playInline(card); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.track-form').forEach(function (form) {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var section = form.closest('.track-wrap');
    var orderNum = form.querySelector('[name="orderNumber"]').value.trim();
    var contact = form.querySelector('[name="contact"]').value.trim();
    if (!orderNum || !contact) return;

    var result = section.querySelector('.track-result');
    var title = section.querySelector('.res-title');
    var meta = section.querySelector('.res-meta');

    if (title) title.textContent = "We're checking order " + orderNum;
    if (meta) meta.textContent = 'Looking up details for ' + contact;
    if (result) {
      result.classList.add('show');
      result.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  function buildFileVideo(src){
    var v = document.createElement('video');
    v.className = 'video-embed';
    v.src = src;
    v.controls = true;
    v.playsInline = true;
    v.setAttribute('playsinline','');
    v.preload = 'auto';
    return v;
  }

  function playInline(card){
    var thumb = card.querySelector('.video-thumb');
    if (!thumb || thumb.classList.contains('is-playing')) return;
    var type = card.getAttribute('data-video-type');
    var id = card.getAttribute('data-video-id');
    if (!type) return;

    var node;
    if (type === 'youtube') {
      node = document.createElement('iframe');
      node.className = 'video-embed';
      node.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
      node.allow = 'autoplay; encrypted-media; picture-in-picture';
      node.setAttribute('allowfullscreen','');
    } else if (type === 'vimeo') {
      node = document.createElement('iframe');
      node.className = 'video-embed';
      node.src = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
      node.allow = 'autoplay; fullscreen; picture-in-picture';
      node.setAttribute('allowfullscreen','');
    } else { // direct file URL (.mp4 / .webm / .mov) incl. Shopify Files videos
      // reuse the video element already pre-buffered on hover, if present
      node = card._preloadedVideo || buildFileVideo(id);
      node.autoplay = true;
      // show a spinner until the video can actually play
      thumb.classList.add('is-loading');
      var clearSpin = function(){ thumb.classList.remove('is-loading'); };
      if (node.readyState >= 3) { clearSpin(); }
      else {
        node.addEventListener('canplay', clearSpin, { once: true });
        node.addEventListener('playing', clearSpin, { once: true });
        node.addEventListener('error', clearSpin, { once: true });
      }
    }
    var btn = thumb.querySelector('.play-btn');
    if (btn) btn.remove();
    thumb.classList.add('is-playing');
    if (node.parentNode !== thumb) thumb.appendChild(node);
    if (node.play) { try { node.play(); } catch(e){} }
  }

  function init(){
    document.querySelectorAll('.video-card.has-video').forEach(function(card){
      var thumb = card.querySelector('.video-thumb');
      if (!thumb) return;
      var type = card.getAttribute('data-video-type');
      var id = card.getAttribute('data-video-id');

      // For self-hosted files: start buffering on hover/touch so the
      // video is ready (or nearly ready) by the time the user clicks.
      if (type === 'file' && id) {
        var preload = function(){
          if (card._preloadedVideo) return;
          var v = buildFileVideo(id);
          v.preload = 'auto';
          v.muted = false;
          card._preloadedVideo = v;
          v.load();
        };
        thumb.addEventListener('mouseenter', preload, { once: true });
        thumb.addEventListener('touchstart', preload, { once: true, passive: true });
      }

      thumb.addEventListener('click', function(){ playInline(card); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

  } catch(e) { console.error(e); }
})();
})();
